const pressArticles = [
  {
    title: 'Berliner Tagesspiegel - Interview mit Stephan Peplies: "Olympiasieger scheitern oft bei der Vermarktung"',
    date: "05.03.2018",
    file: "/press/P 1 Berliner Tagesspiegel Pyeon Chang 5.3.2018.pdf",
    category: "Olympics",
  },
  {
    title: 'Socrates-Sponsoring Fachmagazin - Reportage mit Stephan Peplies: "Wo der Winter den Sommer schlagt"',
    date: "2021",
    file: "/press/P 4 Socrates Fachmagazin Sponsoring.pdf",
    category: "Magazine",
  },
  {
    title: 'Oberpfalzmedien - Interview mit Stephan Peplies: "Was ist eigentlich ein Olympiasieg wert?"',
    date: "01.08.2021",
    file: "/press/P 5 Veröffentlichung Oberpfalzmedien 2021.pdf",
    category: "News",
  },
  {
    title: 'Fridericianerbote - Interview mit Stephan Peplies: "Stephan Peplies - vom Latein-LK ins Sportmarketing"',
    date: "2023",
    file: "/press/P 15 230722 Fridericianerbote 2023 - Auszug Peplies (2).pdf",
    category: "News",
  },
  {
    title: 'Werben & Verkaufen - Kolumne von Stephan Peplies: "TV Spot IKEA - Auf den Punkt gebracht"',
    date: "08.09.2008",
    file: "/press/KON_37_2008_47_Highlights_pdf_1.pdf",
    category: "Magazine",
  },
  {
    title:
      'Horizont Sport Business - Kolumne von Stephan Peplies: "Ohne Sockel kein Katalysatoreffekt"',
    date: "2008",
    file: "/press/Ohne Sockel kein Katalysatoreffekt.pdf",
    category: "Magazine",
  },
  {
    title:
      'Frankfurter Allgemeine Zeitung - Reportage über Stephan Peplies und Andrea Henkel: "Der überraschende Werbefeldzug der Unvermittelbaren"',
    date: "07.01.2003",
    file: "/press/SKM_C25820090912000.pdf",
    category: "News",
  },
  {
    title: 'Financial Times - Reportage über Stephan Peplies und Andrea Henkel: "Bewaffnete Wunschschwiegertochter"',
    date: "04.02.2004",
    file: "/press/SKM_C25820090912001.pdf",
    category: "News",
  },
  {
    title: 'Die Welt - Reportage über Sportmanager Ralf Grengel und Stephan Peplies: "Marktplatz der Manager"',
    date: "07.02.2004",
    file: "/press/SKM_C25820090912002.pdf",
    category: "News",
  },
  {
    title: "Campus Magazin, Universität Bayreuth - Dozenten-Team MBA Sportmanagement",
    date: "2007",
    file: "/press/SKM_C25820090912010.pdf",
    category: "News",
  },
  {
    title: 'Wochenendspiegel/Freie Presse - Interview mit Stephan Peplies: "RTL-Dschungelkrone oder Olympiasieg?"',
    date: "18.02.2022",
    file: "/press/P 11 WESST_180222_WESST_10v12_312167.pdf",
    category: "Magazine",
  },
  {
    title: 'Frankfurter Allgemeine Zeitung - Interview mit Stephan Peplies: "Nummer eins ist Skispringen"',
    date: "10.02.2022",
    file: "/press/P 10 F2202102.031.pdf",
    category: "News",
  },
  {
    title: 'SPORT BILD - Reportage Gschwendner Tee mit Interview Lars Dobbertin: "Bender Zwillinge Eistee Werbung"',
    date: "2014",
    file: "/press/HP_B_Tee_SPOBI-ReportageBender_azkze5.pdf",
    category: "Magazine",
  },
  {
    title: "Münchner Abendzeitung - Reportage TeeGschwendner mit den Bender-Zwillingen",
    date: "27.12.2004",
    file: "/press/HP_B_TeeGschwendner_Abendzeitung_Bender_razpkl.pdf",
    category: "News",
  },
  {
    title: "SPORT BILD - Reportage Eric Frenzel-Uhr für C. H. Wolf mit Eric Frenzel",
    date: "2016",
    file: "/press/HP_B_PR_Beispiel_Frenzel_Uhr_C.H.Wolf_kgeaci.pdf",
    category: "News",
  },
  {
    title: "Münchner Abendzeitung - EM-Kolumne Bernd Schneider",
    date: "06.07.2021",
    file: "/press/HP_B_Bernd_Schneider_PR_Kolumnen_pvp1ri.pdf",
    category: "Magazine",
  },
  {
    title: 'Oberpfalzmedien - Nach-Karriere-Projekt „Eric-Frenzel-Trails“ (Teil 1)',
    date: "12.08.2022",
    file: "/press/Nach_Karriere_Projekt_-_Eric_Frenzel_Trails_01_iwan5k.pdf",
    category: "News",
  },
  {
    title: 'Oberpfalzmedien - Nach-Karriere-Projekt „Eric-Frenzel-Trails“ (Teil 2)',
    date: "07.05.2025",
    file: "/press/Nach_Karriere_Projekt_-_Eric_Frenzel_Trails_02_ohhjxa.pdf",
    category: "News",
  },
];

export default pressArticles;
